import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect, useDispatch } from 'react-redux';
import { createEmail, createPhone } from '../../../../redux/actions/userActions';
import SelectRecovery from '../../../../components/SelectRecovery';
import FieldInput from '../../../../components/FieldInput';

const StepFirst = ({ phone, email, activePhone, setActive, recovery, btnDisabled }) => {
    const dispatch = useDispatch();
    return (
        <Fragment>
            <div className="mb-4">
                <SelectRecovery title='Тип востановления' active={activePhone} func={setActive} />
            </div>
            {activePhone ?
                <div className="mb-3">
                    <FieldInput
                        id='phone'
                        type='tel'
                        name='phone'
                        mask={true}
                        value={phone.value}
                        placeholder='Ваш номер телефона'
                        onchange={e => dispatch(createPhone(e))}
                        validation={{ status: phone.validation, message: phone.message }}
                    />
                </div>
                :
                <div className="mb-3">
                    <FieldInput
                        id='email'
                        type='email'
                        name='email'
                        value={email.value}
                        placeholder='Ваш Email'
                        onchange={e => dispatch(createEmail(e))}
                        validation={{ status: email.validation, message: email.message }}
                    />
                </div>
            }
            <div className="d-flex justify-content-center justify-content-md-end mt-4">
                <button onClick={recovery} className='btn btn_red btn_md' disabled={btnDisabled}>
                    Востановить
                </button>
            </div>
        </Fragment>
    );
};

const mapStateToProps = state => {
    return {
        phone: {
            value: state.user.phone,
            validation: state.user.phoneStatus.validation,
            message: state.user.phoneStatus.message
        },
        email: {
            value: state.user.email,
            validation: state.user.emailStatus.validation,
            message: state.user.emailStatus.message
        }
    };
};

export default connect(mapStateToProps, null)(StepFirst);

StepFirst.propTypes = {
    phone: PropTypes.object,
    setPhone: PropTypes.func,
    email: PropTypes.object,
    setEmail: PropTypes.func,
    activePhone: PropTypes.bool,
    setActive: PropTypes.func,
    recovery: PropTypes.func,
    btnDisabled: PropTypes.bool,
};